import ViewNavBarContainer from 'views/molecules/viewNavBar/ViewNavBarContainer';

export default ViewNavBarContainer;
